// @flow

/* eslint-disable ta-code-conventions/has-matching-test */
import * as React from 'react';
import Skeleton from '@ta/styleguide.skeleton';
import styles from './FeedLoadingSkeleton.less';

type Props = {
  numSections: number,
};

// Repeat the loading skeleton view  numSections time
const FeedLoadingSkeleton = (props: Props) => {
  const skeletons = [];
  // Using a plain-old-for-loop here for perf reasons.
  for (let i = 0; i < props.numSections; i++) {
    skeletons.push(
      <div className={`ui_card section ${styles.container}`} key={i}>
        <div className={styles.avatar_cutout} />
        <div className={styles.avatar_vertical_bar} />
        <div className={styles.avatar_horizontal_bar} />
        <div className={styles.line_one_cutout} />
        <div className={styles.line_two_cutout} />
        <div className={styles.line_three_cutout} />
        <div className={styles.line_four_cutout} />
        <div className={styles.line_five_cutout} />
        <div className={styles.line_six_cutout} />
        <div className={styles.line_seven_cutout} />
        <div className={styles.background}>
          <Skeleton height="100%" />
        </div>
      </div>,
    );
  }
  return skeletons;
};

export default FeedLoadingSkeleton;
